import { CREATE_REQUEST_ROUTE } from './routeRegistry'
import { useIsPermitted } from './useIsPermitted'

/**
 * Whether to offer starting a request. Anything but a firm yes hides the entry point: a request
 * started on a withheld answer would be refused at the endpoint.
 */
export const useCanCreateRequest = (): boolean => useIsPermitted(CREATE_REQUEST_ROUTE)
